// extracted by mini-css-extract-plugin
export default {"root":"FormEventNew_root__stbEN","firstRow":"FormEventNew_firstRow__4AY+Y"};